import React from "react";
import { cn } from "../../../lib/cn";

/**
 * Switch — ui-v2.5. Booleano de EFECTO INMEDIATO. CONTROLADO: `checked` + `onChange`.
 * Especificación: ui-v2.5-catalogo-componentes.html · sección Switch.
 *
 * NOTA: para ELEGIR ENTRE DOS OPCIONES no se usa Switch, se usa <ToggleGroup>. El Switch
 * es solo activar/desactivar algo (recurso, tarea, permiso) con efecto inmediato.
 *
 * <Switch checked={on} onChange={setOn} />
 * <Switch checked={on} onChange={setOn} disabled label="Teléfono de empresa" />
 */

export function Switch({ checked = false, onChange, disabled = false, label, className }) {
  const control = (
    <button
      type="button"
      role="switch"
      aria-checked={!!checked}
      disabled={disabled}
      onClick={() => onChange?.(!checked)}
      className={cn(
        "relative inline-block h-5 w-9 shrink-0 rounded-v25-full transition-colors duration-200",
        "focus-visible:outline-none focus-visible:shadow-v25-focus",
        checked ? "bg-v25-brand-600" : "bg-v25-ink-300",
        disabled && "cursor-not-allowed opacity-[0.45]",
        !label && className
      )}
    >
      <span
        className={cn(
          "absolute left-0.5 top-0.5 h-4 w-4 rounded-v25-full bg-white shadow-[0_1px_2px_rgba(0,0,0,0.15)] transition-transform duration-200",
          checked && "translate-x-4"
        )}
      />
    </button>
  );

  if (!label) return control;
  return (
    <span className={cn("inline-flex items-center gap-2", className)}>
      {control}
      <span className={cn("text-sm", disabled ? "text-v25-ink-400" : "text-v25-ink-700")}>{label}</span>
    </span>
  );
}
